// extracted by mini-css-extract-plugin
export var container = "_3o-0";
export var disabled = "_3o-4";
export var fullWidth = "_3o-3";
export var lined = "_3o-1";
export var selected = "_3o-5";
export var tab = "_3o-2";